import type { CompoundMarketTemplate, TemplateView } from '@ps/isp-web-services-types';

export const isCompoundMarketTemplate = (
  template: TemplateView['template']
): template is CompoundMarketTemplate => 'marketIds' in template && 'config' in template;
